import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    loginUserResult: false,
    loginUserLoading: false,
    logoutUserResult: false,

    updateAkunResult: false,
    updateAkunLoading: false,

    changePasswordResult: false,
    changePasswordLoading: false,
  },
  reducers: {
    authReducer: (state, action) => {
      const { type, payload } = action.payload;
      switch (type) {
        case "LOGIN_USER":
          return {
            ...state,
            loginUserResult: payload.data,
            loginUserLoading: payload.loading,
          };
        case "LOGOUT_USER":
          return {
            ...state,
            logoutUserResult: payload.data,
          };
        case "UPDATE_AKUN":
          return {
            ...state,
            updateAkunResult: payload.data,
            updateAkunLoading: payload.loading,
          };
        case "CHANGE_PASSWORD":
          return {
            ...state,
            changePasswordResult: payload.data,
            changePasswordLoading: payload.loading,
          };
        default:
          return state;
      }
    },
  },
});

export const { authReducer, userReducer } = authSlice.actions;

export default authSlice.reducer;
